import { createTypes } from '../../utils/helpers';

const UNITS_OF_MEASURES_FETCH: any = createTypes('UNITS_OF_MEASURES_FETCH');
export { UNITS_OF_MEASURES_FETCH };
